// extracted by mini-css-extract-plugin
export default {"main":"main_main__AXwpk","title":"main_title__quGWG"};